//--------------- IMPORTAÇÕES ---------------//
import { createContext, useState } from "react";



//--------------- CRIAÇÃO DO CONTEXTO DE TAGS ---------------//
export const TrafegoContext = createContext();



//--------------- EXPORTAÇÃO DO PROVIDER DO CONTEXTO DE TAGS ---------------//
export const TrafegoProvider = ({ children }) => {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const [groups, setGroups] = useState([]); // Estado que armazena a lista dos grupos existentes
    const [idGroupSelected, setIdGroupSelected] = useState(""); // Estado que armazena o nome do Grupo selecionado pelo usuário
    const [startDateFilter, setStartDateFilter] = useState(""); // Estado que armazena a Data Inicial selecionada pelo usuário
    const [endDateFilter, setEndDateFilter] = useState(""); // Estado que armazena a Data Final selecionada pelo usuário
    const [report, setReport] = useState([]); //  Estado que armazena a lista do Relatório
    


    //--------------- RETORNO DO PROVIDER ---------------//
    return (
        <TrafegoContext.Provider value={{
            groups, setGroups, idGroupSelected, setIdGroupSelected, startDateFilter, setStartDateFilter, endDateFilter, setEndDateFilter, report, setReport
        }}>
            {children}
        </TrafegoContext.Provider>
    );



};